module.exports = __webpack_public_path__ + "img/food.72dae54a.svg";